import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import Vuelidate from 'vuelidate'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueMask from 'v-mask'
import VueRouter from 'vue-router'
import VueClip from 'vue-clip'
import VueCurrencyFilter from 'vue-currency-filter'
import VueToast from 'vue-toast-notification'
import 'vue-toast-notification/dist/theme-sugar.css'
import vco from "v-click-outside"
import router from './router/index'
import money from 'v-money'
import VueCurrencyInput from 'vue-currency-input'
import VueFilterDateFormat from 'vue-filter-date-format';
import moment from 'moment';
require('moment/locale/pt-br');
import VueSocketIO from 'vue-socket.io'

import "@/design/index.scss";
import VueSweetalert2 from 'vue-sweetalert2';
import store from '@/state/store'

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

import App from './App.vue'

Vue.use(VueRouter)
Vue.use(vco)

Vue.config.productionTip = false

Vue.use(new VueSocketIO({
  debug: false,
  connection: process.env.VUE_APP_API_URL,
  vuex: {
      store,
      actionPrefix: 'SOCKET_',
      mutationPrefix: 'SOCKET_'
  },
}))

Vue.use(VueFilterDateFormat);
Vue.use(VueCurrencyFilter, {
  symbol : 'R$',
  thousandsSeparator: '.',
  fractionCount: 2,
  fractionSeparator: ',',
  symbolPosition: 'front',
  symbolSpacing: true
})

Vue.use(money, { precision: 2 })
Vue.use(VueCurrencyInput, {
  globalOptions: { currency: null, locale: 'pt-BR', autoDecimalMode: true, precision: 2 },
})

Vue.use(Loading, {
  color: '#f8ae1f',
  width: 45,
  height: 45,
  canCancel: false,
})

Vue.use(require('vue-moment'), {
  moment
})

Vue.use(VueClip)
Vue.use(VueToast)
Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.use(VueMask)
Vue.use(require('vue-chartist'))
Vue.use(VueSweetalert2);
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAbvyBxmMbFhrzP9Z8moyYr6dCr-pzjhBE',
    libraries: 'places',
  },
  installComponents: true
})
Vue.component('apexchart', VueApexCharts)
Vue.directive()

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
